import api from "@/api";
import dayjs from "@/plugins/vue-dayjs";
import { initApplicationSchedule } from "./schedule.inits";

/** @type {import("vuex").Module} */
export const store = {
    namespaced: true,
    state: {
        items: [],
    },
    getters: {
        schedule(state) {
            return initApplicationSchedule(state.items?.[0]);
        },
        isStop(state, getters) {
            /** @type {{schedule: import("./schedule.inits").ApplicationSchedule}} */
            let { schedule } = getters;
            return schedule.stops;
        },
        isDead(state, getters) {
            /** @type {{schedule: import("./schedule.inits").ApplicationSchedule}} */
            let { schedule } = getters;
            return !dayjs().isBefore(schedule.deadAt);
        },
        isBeforeOpen(state, getters) {
            /** @type {{schedule: import("./schedule.inits").ApplicationSchedule}} */
            let { schedule } = getters;
            return dayjs().isBefore(schedule.openAt);
        },
        message_beforeOpen(state, getters) {
            /** @type {{schedule: import("./schedule.inits").ApplicationSchedule}} */
            let { schedule } = getters;
            return schedule.message?.beforeOpen;
        },
        message_dead(state, getters) {
            /** @type {{schedule: import("./schedule.inits").ApplicationSchedule}} */
            let { schedule } = getters;
            return schedule?.message?.dead;
        },
        message_dead2(state, getters) {
            /** @type {{schedule: import("./schedule.inits").ApplicationSchedule}} */
            let { schedule } = getters;
            return schedule?.message?.dead2;
        },
        message_stop(state, getters) {
            /** @type {{schedule: import("./schedule.inits").ApplicationSchedule}} */
            let { schedule } = getters;
            console.log({ schedule });
            return schedule?.message?.stop;
        },
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        },
    },
    actions: {
        async getItems({ state, commit }) {
            let { schedules } = await api.v1.application.schedules.gets();
            commit("setItems", schedules);
        },
    },
};

export default store;
